import { useTrans } from '@/shared/hooks/useTranslation';
import { usePlanLimitToastAction } from '@/viewmodel/features/etlSource';
import { useQuotaBlocks } from '@/viewmodel/features/quota/hooks/useQuotaBlocks';
import { quotaBannerText } from '@/viewmodel/features/quota/mappers/quotaBannerText';
import type { QuotaBannerViewModel } from '@/viewmodel/features/quota/types';

export function useQuotaBannerViewModel(): QuotaBannerViewModel {
  const { t, i18n } = useTrans();
  const { blocks } = useQuotaBlocks();
  const planAction = usePlanLimitToastAction();

  return {
    lines: blocks.map((block) => ({
      key: block.line,
      text: quotaBannerText(block, t, i18n.language),
    })),
    planActionLabel: planAction.label,
    openPlanAction: planAction.onPress,
  };
}
